import { IconTrashX } from '@tabler/icons-react';
import Button from '../../../shared/Button';
import styles from './ScenarioElement.module.css';
import { scenarioService } from '../../../features/Scenario/scenarioService';

type Props = {
	name: string;
	onDelete: () => void;
};

const ScenarioElement = ({ name, onDelete }: Props) =>
{
	const handleDelete = () =>
	{
		scenarioService.delete(name)
			.then(() =>
			{
				console.log(`Scenario ${name} deleted successfully`);
				onDelete();
			})
			.catch(error =>
			{
				console.error('Error deleting scenario:', error);
			});
	};

	return (
		<div className={styles.scenarioElement}>
			<p>{name}</p>
			<Button icon={<IconTrashX />} onClick={handleDelete} frameless></Button>
		</div>
	);
};

export default ScenarioElement;